import { render, staticRenderFns } from "./DteStandardFooterSection.vue?vue&type=template&id=227d9d36"
import script from "./DteStandardFooterSection.vue?vue&type=script&lang=js"
export * from "./DteStandardFooterSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports